import * as React from 'react';
import { Input } from 'antd';
import ColorPicker from 'rc-color-picker';
import 'rc-color-picker/assets/index.css';

interface ColorInputProps {
  name: string;
  value?: string;
  onChange?: Function;
}

class ColorInput extends React.Component<ColorInputProps> {

  private defaultColor = '#36c';

  constructor(props: ColorInputProps) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  public componentDidMount() {
    if (!(this.props.value && this.isValidColor(this.props.value))) {
      if (this.props.onChange) {
        this.props.onChange({ target: { name: this.props.name, value: this.defaultColor } });
      }
    }
  }

  public render() {
    const colorValue = this.props.value && this.isValidColor(this.props.value)
      ? this.props.value
      : this.defaultColor;

    return (
      <>
        <ColorPicker
          color={colorValue}
          defaultColor={colorValue}
          onChange={this.onChange}
        >
          <Input
            name={this.props.name}
            className={'rc-color-picker-trigger'}
            value={colorValue}
            readOnly={true}
          />
        </ColorPicker>
      </>
    );
  }

  private isValidColor(color: string) {
    return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(color);
  }

  private onChange(data: any) {
    if (this.props.onChange && data && data.color) {
      this.props.onChange({ target: { name: this.props.name, value: data.color } });
    }
  }
}

export default ColorInput;


// WEBPACK FOOTER //
// ./src/components/Form/components/ColorInput/ColorInput.tsx